import { LinkButton } from '@cian/ui-kit/button';
import { useDeviceType } from '@cian/ui-kit/responsive';
import cn from 'classnames';
import * as React from 'react';
import { useSelector } from 'react-redux';

import * as styles from './Buttons.css';
import { EButtonGroupType, getButtonGroupType } from './utils'; // eslint-disable-next-line import/no-restricted-paths
import { useIsDailyrentOnlineBookingEnabled } from '../../../common/hooks/useIsDailyrentOnlineBookingEnabled';
import { IDailyRentOfferForMobileSite } from '../../../common/repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { selectABCActionButtonExpGroup } from '../../../common/selectors/experiments/selectABCActionButtonExpGroup';
import { ChatButton } from '../ChatButton';

interface IButtonProps {
  className?: string;
  offer: IDailyRentOfferForMobileSite;
  offerLink: string;
  onMoreClick(): void;
  onBookClick(): void;
  onChatClick(): void;
}

export const ButtonsForAbcExpContainer = ({ className, offer, offerLink, onMoreClick, onChatClick }: IButtonProps) => {
  const deviceType = useDeviceType();
  const isDailyrentOnlineBookingEnabled = useIsDailyrentOnlineBookingEnabled();
  const actionButtonExpGroup = useSelector(selectABCActionButtonExpGroup);

  const buttonGroup = getButtonGroupType({
    offer,
    deviceType,
    isDailyrentOnlineBookingEnabled,
  });

  if (actionButtonExpGroup === 'B') {
    switch (buttonGroup) {
      case EButtonGroupType.CIAN_OFFER_MOBILE_ONLINE_BOOKING:
      case EButtonGroupType.CIAN_OFFER_MOBILE: {
        return (
          <div className={cn(styles['root'], className)}>
            <LinkButton size="L" theme="fill_primary" fullWidth href={offerLink} target="_blank" onClick={onMoreClick}>
              Подробнее
            </LinkButton>
            <ChatButton offer={offer} onClick={onChatClick} size="L" short />
          </div>
        );
      }
      case EButtonGroupType.CIAN_OFFER_DESKTOP_ONLINE_BOOKING:
      case EButtonGroupType.CIAN_OFFER_DESKTOP:
      case EButtonGroupType.PARTNER_OFFER_MOBILE:
      case EButtonGroupType.PARTNER_OFFER_DESKTOP: {
        return (
          <div className={cn(styles['root'], styles['root_desktop'], className)}>
            <LinkButton size="L" theme="fill_primary" fullWidth href={offerLink} target="_blank" onClick={onMoreClick}>
              Подробнее
            </LinkButton>
          </div>
        );
      }
    }
  }

  // Для группы C скрываем кнопки
  return null;
};
